import { render } from "./LimitedCompany.vue?vue&type=template&id=04a3e8be&scoped=true"
import script from "./LimitedCompany.vue?vue&type=script&lang=js"
export * from "./LimitedCompany.vue?vue&type=script&lang=js"

import "./LimitedCompany.vue?vue&type=style&index=0&id=04a3e8be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a3e8be"]])

export default __exports__